/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Dl_Faq_A4Inputs */

const en_pc_dl_faq_a4 = /** @type {(inputs: Pc_Dl_Faq_A4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes. The universal .dmg runs natively on both, and it is signed and notarized by Apple, so it opens normally on first launch.`)
};

const zh_pc_dl_faq_a4 = /** @type {(inputs: Pc_Dl_Faq_A4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`是的。通用版 .dmg 可在两者上原生运行，并经过 Apple 签名和公证，首次启动即可正常打开。`)
};

/**
* | output |
* | --- |
* | "Yes. The universal .dmg runs natively on both, and it is signed and notarized by Apple, so it opens normally on first launch." |
*
* @param {Pc_Dl_Faq_A4Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_dl_faq_a4 = /** @type {((inputs?: Pc_Dl_Faq_A4Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Dl_Faq_A4Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_dl_faq_a4(inputs)
	return zh_pc_dl_faq_a4(inputs)
});
export { pc_dl_faq_a4 as "pc.dl.faq.a4" }